import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { QRButton } from '@base/src/app/models/qr-button.model';

@Component({
  selector: 'app-dialog-delete-note',
  templateUrl: './dialog-delete-note.component.html',
  styleUrls: ['./dialog-delete-note.component.scss']
})
export class DialogDeleteNoteComponent implements OnInit {
  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() delete: EventEmitter<boolean> = new EventEmitter<boolean>();


  buttonCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cancelar'
  };

  buttonDelete: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Eliminar'
  };

  constructor() {}

  ngOnInit(): void {}

  confirmProcess(): void {
    this.delete.emit(true);
  }

  closeOverlay(): void {
    this.change.emit(false);
  }
}
